const applyBanner = () => {
	const banners = document.querySelectorAll('.banner');
	const pageTitle = document.querySelector('section');
	const sidebar = document.querySelector('.aside');

	if(banners) {
		banners.forEach(banner => {
		
			const bannerShow = banner.children[0];
			const bannerHidden = banner.children[1];

			bannerShow.addEventListener("click", () => {
				console.log('click')
				bannerHidden.classList.toggle("show");
			})
		})
	}
}

export {applyBanner}
